import { COLORS } from '@constants/colors';
import { alpha, createTheme } from '@mui/material/styles';
export const theme = createTheme({
    palette: {
        primary: {
            main: COLORS.primary.dark,
            light: COLORS.primary.light,
        },
        error: {
            main: COLORS.error.main,
        },
        success: {
            main: COLORS.success.main,
        },
        background: {
            default: COLORS.background.default,
            paper: COLORS.background.paper,
        },
        text: {
            primary: COLORS.text.primary,
            secondary: COLORS.text.secondary,
            disabled: COLORS.text.disabled,
        },
        gradient: {
            primary: COLORS.gradients.primary,
        },
        infoBox: {
            background: COLORS.background.infoBox,
            border: COLORS.border.infoBox,
        },
    },
    typography: {
        fontFamily: '"Open Sans", "Helvetica", "Arial", sans-serif',
        h1: {
            fontSize: '24px',
            fontWeight: 700,
            lineHeight: 1.5,
        },
        body1: {
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: 1.5,
        },
        body2: {
            fontSize: '20px',
            fontWeight: 400,
            lineHeight: 1.5,
        },
        subtitle1: { fontSize: '20px', fontWeight: 700, lineHeight: 1.5 },
        subtitle2: { fontSize: '18px', fontWeight: 700, lineHeight: 1.5 },
        caption: {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: 1.5,
        },
        button: {
            fontSize: '16px',
            fontWeight: 700,
            textTransform: 'uppercase',
            lineHeight: 1.5,
        },
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    height: 42,
                    backgroundImage: COLORS.gradients.primary,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '5px',
                    paddingTop: '12px',
                    paddingBottom: '12px',
                    paddingLeft: '24px',
                    paddingRight: '24px',
                    minHeight: '46px', // 22px height + 12px top + 12px bottom
                },
                contained: {
                    '&.MuiButton-containedPrimary': {
                        background: COLORS.gradients.button,
                        '&:hover': {
                            background: COLORS.gradients.button,
                            opacity: 0.9,
                        },
                    },
                    ':disabled': {
                        color: COLORS.neutral.medium,
                    },
                },
                outlined: {
                    '&.MuiButton-outlinedError': {
                        borderColor: COLORS.error.main,
                        color: COLORS.error.main,
                        '&:hover': {
                            borderColor: COLORS.error.main,
                            backgroundColor: alpha(COLORS.error.main, 0.04),
                        },
                    },
                },
            },
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    // Customize slider height
                    height: 4,
                },
                thumb: {
                    // Customize thumb size
                    width: 16,
                    height: 16,
                    '&:hover': {
                        boxShadow: `0px 0px 0px 8px ${alpha(COLORS.primary.button, 0.16)}`,
                    },
                    '&.Mui-active': {
                        boxShadow: `0px 0px 0px 12px ${alpha(COLORS.primary.button, 0.16)}`,
                    },
                },
                track: {
                    // Customize track (filled part)
                    height: 4,
                },
                rail: {
                    // Customize rail (unfilled part)
                    height: 4,
                    opacity: 1,
                    backgroundColor: COLORS.neutral.light, // Or use your custom color
                },
                valueLabel: {
                    // Customize value label (shown on hover)
                    fontSize: 12,
                },
            },
            defaultProps: {
                // Set default props for all sliders
                size: 'medium',
            },
        },
        MuiAlert: {
            styleOverrides: {
                filled: {
                    borderRadius: '8px',
                    boxShadow: `0 2px 12px ${alpha(COLORS.text.primary, 0.2)}`,
                    alignItems: 'center',
                },
                filledInfo: ({ theme }) => ({
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.primary.contrastText,
                }),
            },
        },
    },
});
